import React, {Component} from 'react';
import produce from 'immer';
import withLifecycles from 'async-lifecycles';
import {Button, Form, Icon} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import toastr from 'toastr';

import {connect} from 'react-redux';
import BlacklistDomain from '../../store/services/blacklistDomain';
import FormContainer from '../form-components/FormContainer';
import {ErrorMessages} from '../form-components/ErrorMessages';
import BlacklistDomainForm from './BlacklistDomainForm';

class NewBlacklistDomainScreen extends Component {
  state = {
    loading: false,
    blacklistDomain: {
      domainName: '',
    },
    error: {},
    userError: false,
    hasUserId: false,
    user: {},
  };

  _mutate = cb => {
    this.setState(produce(cb));
  };

  _handleTextChanged = (event, {name, value}) => {
    this._mutate(draft => {
      draft.blacklistDomain[name] = value;
    });
  };

  _loadBlacklistedDomains = (pageNumber, searchTerm) => {
    withLifecycles(
      () =>
        BlacklistDomain.fetch({
          request: {
            page: pageNumber,
            pageSize: 20,
          },
          searchTerm: searchTerm,
          orderByName: false,
        }),
      ({loading, data}) => {
        this.setState({activePage: pageNumber + 1});
        this.setState(
          produce(draft => {
            draft.loading = loading;

            if (data && !data.hasErrors) {
              draft.pageInfo = data.result;
            }
          })
        );
      }
    );
  };

  _save = () => {
    withLifecycles(
      () => BlacklistDomain.blacklistDomain(this.state.blacklistDomain),
      ({loading, data, error}) => {
        this._mutate(draft => {
          draft.loading = loading;
          draft.error = error;

          if (data && !data.hasErrors) {
            this._loadBlacklistedDomains(0, '');
            toastr.success('Blacklisted Domain Created');
            this.props.history.push('/manage/blacklists/domains');
          }
        });
      }
    );
  };

  render() {
    const {error, loading, blacklistDomain} = this.state;

    return (
      <FormContainer loading={loading}>
        <Form onSubmit={this._save}>
          <BlacklistDomainForm
            blacklistDomain={blacklistDomain}
            handleTextChanged={this._handleTextChanged}
            isReadOnly={false}
            isBeingEdited={false}
          />
          <ErrorMessages error={error} />
          <Button type="submit">
            <Icon
              style={{paddingRight: '15px'}}
              name="eye slash"
              color="Black"
            />
            Blacklist Domain
          </Button>
          <Button basic as={Link} to="/manage/blacklists/domains">
            Cancel
          </Button>
        </Form>
      </FormContainer>
    );
  }
}

const mapStateToProps = ({customers, identity}) => ({
  customers: customers.data,
  role: identity.user.role,
});

export default connect(mapStateToProps)(NewBlacklistDomainScreen);
